import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import BasePopup from '@r1-frontend/ui-react/components/popups/basePopup';

export const SBasePopup = styled(BasePopup)`
    padding-bottom: 12px !important;
`;

export const HideSearchBtn = styled(BaseButton)`
    padding-left: 0;
    padding-top: 2px;
    padding-bottom: 3px;
`;

export const SThrobber = styled(Throbber)`
    position: absolute;
`;
